import { useContext } from 'react';
import { EventDraftContext } from './EventDraftContext.js';

/**
 * Read-only fallback for isolated body renders that are not wrapped by the
 * per-event draft provider.
 */
const READ_ONLY = {
  editing: false,
  draft: '',
  startEdit: () => {},
  setDraft: () => {},
  cancelEdit: () => {},
  itemDecisions: {},
  itemCorrections: {},
  setItemDecision: () => {},
  setItemDecisions: () => {},
  breakGlassApprovers: null,
  setBreakGlassApprovers: () => {},
};

export function useEventDraft() {
  return useContext(EventDraftContext) ?? READ_ONLY;
}
